import React, {memo} from "react";
import {useNavigate} from "react-router-dom";
import RenderIf from "@/components/Global/RenderIf/RenderIf";

import styles from "./Button.module.scss";

export default memo(function Button({
  className = "",
  onClick,
  variant = "primary",
  children,
  href,
  target,
  isLoading,
  loadingText = "Submitting...",
  behavior = "smooth",
  ...rest
}) {
  const navigate = useNavigate();

  const handleClick = event => {
    onClick && onClick(event);

    const isMainEvent = event.button === 0; // left mouse button
    const isModifiedEvent = event.metaKey || event.altKey || event.ctrlKey || event.shiftKey;
    const isManagementEvent = target === undefined || target === "_self";
    const containHttp = href && href?.startsWith("http");

    if (isMainEvent && isManagementEvent && !isModifiedEvent && !containHttp) {
      event.preventDefault();
      if (href && href.startsWith("#")) {
        const targetElement = document.querySelector(href);
        if (targetElement) {
          if ("scrollBehavior" in document.documentElement.style && behavior == "smooth") {
            targetElement.scrollIntoView({behavior: "smooth"});
          } else {
            targetElement.scrollIntoView();
          }
        }
      } else {
        return navigate(href);
      }
    }

    if (!containHttp) return window.history.pushState({}, "", href);
  };

  if (!target && href?.includes("http")) target = "_blank";

  return (
    <>
      <RenderIf isTrue={href}>
        <a
          onClick={handleClick}
          href={href}
          target={target}
          variant={variant}
          className={`${styles.btn} ${className}`}
          {...rest}>
          <RenderIf isTrue={isLoading}>
            <div className="row justify-content-center">
              <div className="col-auto">
                <div className="spinner-border spinner-border-sm" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
              <div className="col-auto">{loadingText}</div>
            </div>
          </RenderIf>
          <RenderIf isTrue={!isLoading}>{children}</RenderIf>
        </a>
      </RenderIf>

      <RenderIf isTrue={!href}>
        <button
          variant={variant}
          className={`${styles.btn} ${className}`}
          onClick={e => {
            onClick && onClick(e);
          }}
          {...rest}>
          <RenderIf isTrue={isLoading}>
            <div className="row justify-content-center">
              <div className="col-auto">
                <div className="spinner-border spinner-border-sm" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
              <div className="col-auto">{loadingText}</div>
            </div>
          </RenderIf>
          <RenderIf isTrue={!isLoading}>{children}</RenderIf>
        </button>
      </RenderIf>
    </>
  );
});
